import Vue from "vue";
import Router from "vue-router";
import Login from "@/modules/auth/Login";
import RecoveryPassword from "@/modules/auth/RecoveryPassword";
import ChangePassword from "@/modules/auth/ChangePassword";
import InviteUser from "@/modules/auth/InviteUser";
import InviteNewUser from "@/modules/auth/InviteNewUser";
import Register from "@/modules/auth/Register";
import CanceledAccount from "@/modules/auth/CanceledAccount";
import Onboarding from "@/modules/onboarding/Onboarding";
import SelectPlan from "@/modules/onboarding/SelectPlan";

import Product from "@/modules/product/Product";
import ProductList from "@/modules/product/List";
import AdditionalValue from "@/modules/additionalValue/AdditionalValue";
import ConfigIntegration from "@/modules/config/Integration";
import ConfigAccount from "@/modules/config/Account";
import HowTo from "@/modules/howto/HowTo";
import FacebookAds from "@/modules/oauth/FacebookAds";
import GoogleAds from "@/modules/oauth/GoogleAds";
import TikTokAds from "@/modules/oauth/TikTokAds";
import NuvemShopOauth from "@/modules/oauth/NuvemShopOauth";
import YampiOauth from "@/modules/oauth/YampiOauth";
import LoginOauth from "@/modules/oauth/LoginOauth";
import Canny from "@/modules/canny/Canny";
import Tracking from "@/modules/tracking/Tracking";
import TrackingV2 from "@/modules/trackingV2/TrackingV2";
import ShortLink from "@/modules/shortLink/ShortLink";
import ShortLinkWhats from "@/modules/shortLink/ShortLinkWhats";
import TimeLineLog from "@/modules/timeLineLog/TimeLineLog";
import PopulatePixel from "@/modules/populatePixel/PopulatePixel";
import Vsl from "@/modules/vsl/List";
import VslEdit from "@/modules/vsl/Edit";
import VslDetail from "@/modules/vsl/Detail";

import Dash from "@/modules/dash/Dash";
import DashEdit from "@/modules/dash/NewDash";

import Track from "@/modules/trackingV2/Track";
import Config from "@/modules/config/Config";
import CampaignDash from "@/modules/campaign/CampaignDash";

import Source from "@/modules/source/Dash";

import Jorney from "@/modules/jorney/Dash";
import JorneyDetailSale from "@/modules/jorney/SaleDetail";
import JorneyDetailLead from "@/modules/jorney/LeadDetail";
import JorneyDetailMsg from "@/modules/jorney/MsgDetail";

import Insight from "@/modules/insight/Insight";
import Sale from "@/modules/sale/Sale";
import SaleRecovery from "@/modules/sale/SaleRecovery";
import CalculateProduct from "@/modules/calculate/CalculateProduct";
import TopProduct from "@/modules/top/TopProduct";
import TopSupplier from "@/modules/top/TopSupplier";
import RateStore from "@/modules/ratestore/RateStore";
import Specialist from "@/modules/specialist/Specialist";
import Bonus from "@/modules/bonus/Bonus";
import Affiliate from "@/modules/affiliate/Affiliate";
import Subscription from "@/modules/subscription/Subscription";
import SubscriptionAccount from "@/modules/subscription/SubscriptionAccount";
import SubscriptionWhats from "@/modules/subscription/SubscriptionWhats";
import Export from "@/modules/export/Export";

import CustomConversion from "@/modules/customconversion/CustomConversion";
import CustomConversionEdit from "@/modules/customconversion/Edit";

import Funnel from "@/modules/funnel/Funnel";
import FunnelEdit from "@/modules/funnel/Edit";
import FunnelDetail from "@/modules/funnel/FunnelDetail";

import Pages from "@/modules/page/Page";

import Homev2 from "@/modules/home/Homev2";

import VerifiedTag from "@/modules/tag/VerifiedTag";
import Home from "@/modules/Home";
import Account from "@/modules/auth/Account";

import SubscriptionRedirect from "@/modules/auth/SubscriptionRedirect";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Login",
      component: Login,
    },
    {
      path: "/recovery-password",
      name: "RecoveryPassword",
      component: RecoveryPassword,
    },
    {
      path: "/change-password/:rtoken",
      name: "ChangePassword",
      component: ChangePassword,
      props: true,
      meta: {
        breadcrumb: [
          {
            name: "Trocar a senha"
          }
        ]
      }
    },
    {
      path: "/invite-user/:rtoken",
      name: "InviteUser",
      component: InviteUser,
      props: true,
      meta: {
        breadcrumb: [
          {
            name: "Aceitar convite"
          }
        ]
      }
    },
    {
      path: "/invite-new-user/:rtoken",
      name: "InviteNewUser",
      component: InviteNewUser,
      props: true,
      meta: {
        breadcrumb: [
          {
            name: "Aceitar convite para novo usuário"
          }
        ]
      }
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
    },
    {
      path: "/onboarding",
      name: "Onboarding",
      component: Onboarding,
    },
    {
      path: "/onboarding-flow",
      name: "SelectPlan",
      component: SelectPlan,
    },
    {
      path: "/conta-cancelada",
      name: "CanceledAccount",
      component: CanceledAccount,
    },
    {
      path: "/dash/:slug",
      name: "Dash",
      component: Dash,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "profit",
        breadcrumb: [
          {
            name: "Dashboard",
          },
        ],
      },
    },
    {
      path: "/dash/edit/:dash_id",
      name: "DashEdit",
      component: DashEdit,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "profit", 
        breadcrumb: [
          {
            name: "Editar Dashboard",
          },
        ],
      },
    },
    {
      path: "/source/:slug",
      name: "Source",
      component: Source,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "profit",
        breadcrumb: [
          {
            name: "UTMs",
          },
        ],
      },
    },
    {
      path: "/jorney/:slug",
      name: "Jorney",
      component: Jorney,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "profit",
        breadcrumb: [
          {
            name: "Jornada do Cliente",
          },
        ],
      },
    },
    {
      path: "/jorney/sale/:sale_id",
      name: "JorneyDetailSale",
      component: JorneyDetailSale,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "profit",
        breadcrumb: [
          {
            name: "Jornada do Cliente",
          },
          {
            name: "Venda",
          },
          {
            name: "Detalhes",
          },
        ],
      },
    },
    {
      path: "/jorney/lead/:lead_id",
      name: "JorneyDetailLead",
      component: JorneyDetailLead,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "profit",
        breadcrumb: [
          {
            name: "Jornada do Cliente",
          },
          {
            name: "Lead",
          },
          {
            name: "Detalhes",
          },
        ],
      },
    },
    {
      path: "/jorney/msg/:cov_id",
      name: "JorneyDetailConversation",
      component: JorneyDetailMsg,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "profit",
        breadcrumb: [
          {
            name: "Jornada do Cliente",
          },
          {
            name: "Conversa",
          },
          {
            name: "Detalhes",
          },
        ],
      },
    },
    {
      path: "/track/:slug",
      name: "Track",
      component: Track,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "tracking",
        breadcrumb: [
          {
            name: "Trackeamento",
          },
        ],
      },
    },
    {
      path: "/campaigndash/:slug",
      name: "CampaignDash",
      component: CampaignDash,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "profit",
        breadcrumb: [
          {
            name: "Campanhas",
          },
        ],
      },
    },
    {
      path: "/config/:slug",
      name: "Config",
      component: Config,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "config",
        breadcrumb: [
          {
            name: "Configuração",
          },
        ],
      },
    },


    {
      path: "/produtos",
      name: "Product",
      component: ProductList,
      meta: {
        requiresLogin: true,
        permissionName: "product", 
        breadcrumb: [
          {
            name: "Produtos",
          },
        ],
      },
    },

    {
      path: "/produtos/:product_id",
      name: "ProductDetail",
      component: Product,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "product", 
        breadcrumb: [
          {
            name: "Produtos",
            link: "Product",
          },
          {
            name: "Nome do Produto",
          },
        ],
      },
    },
    {
      path: "/pages",
      name: "Pages",
      component: Pages,
      meta: {
        requiresLogin: true,
        permissionName: "pages", 
        breadcrumb: [
          {
            name: "Páginas",
          },
        ],
      },
    },
    {
      path: "/homev2",
      name: "Homev2",
      component: Homev2,
      meta: {
        requiresLogin: true,
        permissionName: "home", 
        breadcrumb: [
          {
            name: "Início",
          },
        ],
      },
    },
    {
      path: "/valores-adicionais",
      name: "AdditionalValue",
      component: AdditionalValue,
      meta: {
        requiresLogin: true,
        permissionName: "additionalvalue", 
        breadcrumb: [
          {
            name: "Valores Adicionais",
          },
        ],
      },
    },
    {
      path: "/origem",
      name: "Tracking",
      component: Tracking,
      meta: {
        requiresLogin: true,
        permissionName: "tracking", 
        breadcrumb: [
          {
            name: "Origem",
          },
        ],
      },
    },
    {
      path: "/hottracker",
      name: "TrackingV2",
      component: TrackingV2,
      meta: {
        requiresLogin: true,
        permissionName: "tracking", 
        breadcrumb: [
          {
            name: "Hot Tracker",
          },
        ],
      },
    },
    {
      path: "/populate-pixel",
      name: "PopulatePixel",
      component: PopulatePixel,
      meta: {
        requiresLogin: true,
        permissionName: "populatepixel", 
        breadcrumb: [
          {
            name: "Retro Alimentação",
          },
        ],
      },
    },
    {
      path: "/vsl",
      name: "VSL",
      component: Vsl,
      meta: {
        requiresLogin: true,
        permissionName: "vsl", 
        breadcrumb: [
          {
            name: "VSL",
          },
        ],
      },
    },
    {
      path: "/vsl/new",
      name: "VSLNew",
      component: VslEdit,
      meta: {
        requiresLogin: true,
        permissionName: "vsl", 
        breadcrumb: [
          {
            name: "Criar VSL",
          },
        ],
      },
    },
    {
      path: "/vsl/edit/:vsl_id",
      name: "VSLEdit",
      component: VslEdit,
      meta: {
        requiresLogin: true,
        permissionName: "vsl", 
        breadcrumb: [
          {
            name: "Editar VSL",
          },
        ],
      },
    },
    {
      path: "/vsl/:vsl_id",
      name: "VSLDetail",
      component: VslDetail,
      meta: {
        requiresLogin: true,
        permissionName: "vsl", 
        breadcrumb: [
          {
            name: "Relatorio VSL",
          },
        ],
      },
    },
    // funnel
    {
      path: "/funnel",
      name: "Funnel",
      component: Funnel,
      meta: {
        requiresLogin: true,
        permissionName: "funnel", 
        breadcrumb: [
          {
            name: "Funnel",
          },
        ],
      },
    },
    {
      path: "/funnel/new",
      name: "FunnelNew",
      component: FunnelEdit,
      meta: {
        requiresLogin: true,
        permissionName: "funnel", 
        breadcrumb: [
          {
            name: "Criar Funnel",
          },
        ],
      },
    },
    {
      path: "/funnel/edit/:funnel_id",
      name: "FunnelEdit",
      component: FunnelEdit,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "funnel", 
        breadcrumb: [
          {
            name: "Editar Funnel",
          },
        ],
      },
    },
    {
      path: "/funnel/:funnel_id",
      name: "FunnelDetail",
      component: FunnelDetail,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "funnel", 
        breadcrumb: [
          {
            name: "Relatorio Funnel",
          },
        ],
      },
    },
    // custom conversion 
    {
      path: "/custom-conversion",
      name: "CustomConversion",
      component: CustomConversion,
      meta: {
        requiresLogin: true,
        permissionName: "custom-conversion", 
        breadcrumb: [
          {
            name: "CustomConversion",
          },
        ],
      },
    },
    {
      path: "/custom-conversion/new",
      name: "CustomConversionNew",
      component: CustomConversionEdit,
      meta: {
        requiresLogin: true,
        permissionName: "custom-conversion", 
        breadcrumb: [
          {
            name: "Criar CustomConversion",
          },
        ],
      },
    },
    {
      path: "/custom-conversion/edit/:conv_id",
      name: "CustomConversionEdit",
      component: CustomConversionEdit,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "custom-conversion", 
        breadcrumb: [
          {
            name: "Editar CustomConversion",
          },
        ],
      },
    },
    {
      path: "/tutoriais",
      name: "HowTo",
      component: HowTo,
      meta: {
        requiresLogin: true,
        breadcrumb: [
          {
            name: "Tutoriais",
          },
        ],
      },
    },
    {
      path: "/sugestoes",
      name: "Canny",
      component: Canny,
      meta: {
        requiresLogin: true,
        breadcrumb: [
          {
            name: "Sugestões",
          },
        ],
      },
    },
    {
      path: "/config/integracoes/",
      name: "ConfigIntegration",
      component: ConfigIntegration,
      meta: {
        requiresLogin: true,
        permissionName: "config", 
        breadcrumb: [
          {
            name: "Configurações",
          },
          {
            name: "Integrações",
            link: "ConfigIntegration",
          },
        ],
      },
    },
    {
      path: "/config/integracoes/:slug",
      name: "ConfigIntegrationDetail",
      component: ConfigIntegration,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "config", 
        breadcrumb: [
          {
            name: "Configurações",
            link: "Config",
            params: { slug: "account" }
          },
          {
            name: "Integrações",
            link: "ConfigIntegration",
          },
        ],
      },
    },
    {
      path: "/config/conta",
      name: "ConfigAccount",
      component: ConfigAccount,
      meta: {
        requiresLogin: true,
        permissionName: "config", 
        breadcrumb: [
          {
            name: "Configurações",
          },
          {
            name: "Conta",
          },
        ],
      },
    },
    {
      path: "/conta",
      name: "Account",
      component: Account,
      meta: {
        requiresLogin: true,
        breadcrumb: [
          {
            name: "Escolher conta",
          },
        ],
      },
    },
    {
      path: "/home",
      name: "Home",
      component: Home,
      meta: {
        requiresLogin: true,
        breadcrumb: [
          {
            name: "Home",
          },
        ],
      },
    },
    {
      path: "/oauth2/facebook-ads/success",
      name: "FacebookAdsSelectAccounts",
      component: FacebookAds,
    },
    {
      path: "/oauth2/google-ads/success",
      name: "GoogleAdsSelectAccounts",
      component: GoogleAds,
    },
    {
      path: "/oauth2/tiktok-ads/success",
      name: "TikTokAdsAdsSelectAccounts",
      component: TikTokAds,
    },
    {
      path: "/oauth2/nuvemshop/success",
      name: "NuvemShop",
      component: NuvemShopOauth,
    },
    {
      path: "/oauth2/yampi/success",
      name: "Yampi",
      component: YampiOauth,
    },
    {
      path: "/oauth2/facebook/login",
      name: "LoginOauthFB",
      component: LoginOauth,
    },
    {
      path: "/oauth2/google/login",
      name: "LoginOauthG",
      component: LoginOauth,
    },
    {
      path: "/oauth2/nuvemshop/login",
      name: "LoginOauthNS",
      component: LoginOauth,
    },
    {
      path: "/oauth2/yampi/login",
      name: "LoginOauthYP",
      component: LoginOauth,
    },
    {
      path: "/specialist",
      name: "Specialist",
      component: Specialist,
      meta: {
        requiresLogin: true,
        permissionName: "specialist",
        breadcrumb: [
          {
            name: "O especialista",
          },
        ],
      },
    },
    {
      path: "/rate/store",
      name: "RateStore",
      component: RateStore,
      meta: {
        requiresLogin: true,
        permissionName: "populate",
        breadcrumb: [
          {
            name: "Avaliação de Loja",
          },
        ],
      },
    },
    {
      path: "/top/supplier",
      name: "TopSupplier",
      component: TopSupplier,
      meta: {
        requiresLogin: true,
        permissionName: "populate",
        breadcrumb: [
          {
            name: "Lista de fornecedores",
          },
        ],
      },
    },
    {
      path: "/top/product",
      name: "TopProduct",
      component: TopProduct,
      meta: {
        requiresLogin: true,
        permissionName: "populate",
        breadcrumb: [
          {
            name: "Lista de produtos",
          },
        ],
      },
    },
    {
      path: "/cal/product",
      name: "CalculateProduct",
      component: CalculateProduct,
      meta: {
        requiresLogin: true,
        permissionName: "calculateproduct",
        breadcrumb: [
          {
            name: "Calculadora de preço para produto",
          },
        ],
      },
    },
    {
      path: "/sales/recovery",
      name: "SaleRecovery",
      component: SaleRecovery,
      meta: {
        requiresLogin: true,
        permissionName: "populate",
        breadcrumb: [
          {
            name: "Recuperar vendas",
          },
        ],
      },
    },
    {
      path: "/sales",
      name: "Sale",
      component: Sale,
      meta: {
        requiresLogin: true,
        permissionName: "populate",
        breadcrumb: [
          {
            name: "Vendas",
          },
        ],
      },
    },
    {
      path: "/insight",
      name: "Insight",
      component: Insight,
      meta: {
        requiresLogin: true,
        permissionName: "insight",
        breadcrumb: [
          {
            name: "Insight",
          },
        ],
      },
    },
    {
      path: "/bonus",
      name: "Bonus",
      component: Bonus,
      meta: {
        requiresLogin: true,
        breadcrumb: [
          {
            name: "Bonus",
          },
        ],
      },
    },
    {
      path: "/affiliate",
      name: "Affiliate",
      component: Affiliate,
      meta: {
        requiresLogin: true,
        breadcrumb: [
          {
            name: "Seja afiliado",
          },
        ],
      },
    },
    {
      path: "/subscription",
      name: "Subscription",
      component: Subscription,
      meta: {
        requiresLogin: true,
        breadcrumb: [
          {
            name: "Assine",
          },
        ],
      },
    },
    {
      path: "/subscription-account",
      name: "SubscriptionAccount",
      component: SubscriptionAccount,
      meta: {
        requiresLogin: true,
        breadcrumb: [
          {
            name: "Projetos Adicionais",
          },
        ],
      },
    },
    {
      path: "/subscription-whats",
      name: "SubscriptionWhats",
      component: SubscriptionWhats,
      meta: {
        requiresLogin: true,
        breadcrumb: [
          {
            name: "WhatsApp Adicionais",
          },
        ],
      },
    },
    {
      path: "/shortlink",
      name: "ShortLink",
      component: ShortLink,
      meta: {
        requiresLogin: true,
        breadcrumb: [
          {
            name: "Links Rastreaveis",
          },
        ],
      },
    },
    {
      path: "/shortlinkwhats",
      name: "ShortLinkWhats",
      component: ShortLinkWhats,
      meta: {
        requiresLogin: true,
        breadcrumb: [
          {
            name: "Links Rastreaveis Whats",
          },
        ],
      },
    },
    {
      path: "/timelinelog",
      name: "TimeLineLog",
      component: TimeLineLog,
      meta: {
        requiresLogin: true,
        breadcrumb: [
          {
            name: "Anotações",
          },
        ],
      },
    },
    {
      path: "/export",
      name: "Export",
      component: Export,
      meta: {
        requiresLogin: true,
        breadcrumb: [
          {
            name: "Exportar Dados",
          },
        ],
      },
    },
    {
      path: "/subscription-redirect",
      name: "SubscriptionRedirect",
      component: SubscriptionRedirect,
      props: true,
      meta: {
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: "/subscription-redirect/:flow",
      name: "SubscriptionRedirectParam",
      component: SubscriptionRedirect,
      props: true,
      meta: {
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: "/verified-tag",
      name: "VerifiedTag",
      component: VerifiedTag,
    },
    {
      path: "*",
      name: "route.notfound",
      redirect: "/home",
    },
  ],
});
